import { ARROW_HEAD_RATIO, SHAPE_KINDS } from '../../config/shapes';
import { withAlpha } from '../../utils/color';

const roundedRect = (ctx, x, y, width, height, radius) => {
  const r = Math.max(0, Math.min(radius || 0, width / 2, height / 2));
  if (typeof ctx.roundRect === 'function') {
    ctx.roundRect(x, y, width, height, r);
  } else {
    ctx.rect(x, y, width, height);
  }
};

const fillAndStroke = (ctx, element) => {
  if (element.fillEnabled !== false) {
    ctx.fillStyle = element.fill;
    ctx.fill();
  }
  if (element.strokeEnabled && element.strokeWidth > 0) {
    ctx.strokeStyle = element.stroke;
    ctx.lineWidth = element.strokeWidth;
    ctx.stroke();
  }
};

export const drawShape = (ctx, element, width, height) => {
  const inset = element.strokeEnabled ? element.strokeWidth / 2 : 0;

  switch (element.kind) {
    case SHAPE_KINDS.ELLIPSE: {
      ctx.beginPath();
      ctx.ellipse(
        width / 2,
        height / 2,
        Math.max(0, width / 2 - inset),
        Math.max(0, height / 2 - inset),
        0,
        0,
        Math.PI * 2,
      );
      fillAndStroke(ctx, element);
      return;
    }
    case SHAPE_KINDS.LINE: {
      ctx.beginPath();
      roundedRect(ctx, 0, 0, width, height, height / 2);
      ctx.fillStyle = element.fill;
      ctx.fill();
      return;
    }
    case SHAPE_KINDS.ARROW: {
      const thickness = height / ARROW_HEAD_RATIO;
      const headLength = Math.min(width * 0.6, height * 0.9);
      const mid = height / 2;
      ctx.beginPath();
      ctx.moveTo(0, mid - thickness / 2);
      ctx.lineTo(width - headLength, mid - thickness / 2);
      ctx.lineTo(width - headLength, 0);
      ctx.lineTo(width, mid);
      ctx.lineTo(width - headLength, height);
      ctx.lineTo(width - headLength, mid + thickness / 2);
      ctx.lineTo(0, mid + thickness / 2);
      ctx.closePath();
      ctx.fillStyle = element.fill;
      ctx.fill();
      return;
    }
    case SHAPE_KINDS.FADE: {
      const gradient =
        element.direction === 'down'
          ? ctx.createLinearGradient(0, 0, 0, height)
          : ctx.createLinearGradient(0, height, 0, 0);
      gradient.addColorStop(0, withAlpha(element.fill, 1));
      gradient.addColorStop(0.45, withAlpha(element.fill, 0.55));
      gradient.addColorStop(1, withAlpha(element.fill, 0));
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, width, height);
      return;
    }
    default: {
      ctx.beginPath();
      roundedRect(
        ctx,
        inset,
        inset,
        Math.max(0, width - inset * 2),
        Math.max(0, height - inset * 2),
        element.cornerRadius,
      );
      fillAndStroke(ctx, element);
    }
  }
};
